import apiService from './apiService';

export const dashboardService = {
    getStats: () => apiService.get('/dashboard/stats'),
    refreshStats: () => apiService.post('/dashboard/stats/refresh')
};
